import React, { useState, useEffect, useCallback } from 'react';
import { completedTask, getAllTask, getAllEmployees, downloadReport } from "../Services/masterService"
import AssignModal from './AssignTaskModal';
import TaskViewModal from '../components/TaskViewModal';
import Modal from '../AlertModal/Modal';
import axios from 'axios';
import API_BASE_URL from "../Services/apiConfig";

const tabStatusMap = {
    'request': 'NEW_REQUEST',
    'assigned': 'ASSIGNED',
    'accepted': 'ACCEPTED',
    'inprogress': 'IN_PROGRESS',
    'collected': 'COLLECTED',
    'handovered': 'HANDOVERED',
    'completed': 'COMPLETED',
    'rejected': 'REJECTED',
    'cancelled': 'CANCELLED',
};


// Helper to format date/time for display
const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
};

// Helper for priority badge
const PriorityBadge = ({ priority }) => (
    <span className={`px-2 py-0.5 ml-2 rounded-full text-xs font-semibold ${priority === 'HIGH' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
        }`}>
        {priority}
    </span>
);


// ----------------------------------------------------------------
// 2. MAIN DASHBOARD COMPONENT
// ----------------------------------------------------------------

function OperationDashboard({ allEmployees, tasks }) {
    const [allTasks, setAllTasks] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null);
    const [allEmployee, setAllEmployee] = useState([]);
    const [activeTab, setActiveTab] = useState('ASSIGNED');
    const [isLoading, setIsLoading] = useState(false);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);

    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [reportDates, setReportDates] = useState({
        fromDate: '',
        toDate: ''
    });


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    const handleAssignAction = (task) => {
        setSelectedTask(task);
        setIsAssignModalOpen(true);
    };

    // Close modal
    const handleCloseModal = () => {
        setIsAssignModalOpen(false);
        setSelectedTask(null);
    };

    // Refresh tasks after successful assignment
    const handleAssignSuccess = () => {
        fetchTasks();
    };

    // API Call to fetch ALL tasks
    const fetchTasks = useCallback(async () => {
        console.log('called')
        setIsLoading(true);
        try {
            const response = await getAllTask();
            if (response.status === 1) {
                setAllTasks(response.data);

            } else {
                console.error("Failed to fetch tasks");
                setAllTasks([]);
            }
        } catch (error) {
            console.error("Network error fetching tasks:", error);
        } finally {
            setIsLoading(false);
        }

        try {
            const response = await getAllEmployees();
            if (response.status === 1) {
                setAllEmployee(response.data.filter(item => item.userType == "LOGISTIC"));
            } else {
                console.error("Failed to fetch tasks");
                setAllEmployee([]);
            }
        } catch (error) {
            console.error("Network error fetching tasks:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);


    // const filteredTasks = allTasks.filter(task => task.status === tabStatusMap[activeTab]);

    const storedUser = localStorage.getItem('user');
    const userInfo = JSON.parse(storedUser)

    const filteredTasks = allTasks.filter(task => {
        const statusMatch = task.status === tabStatusMap[activeTab];

        if (activeTab === 'completed') {
            // console.log(
            //     'Task ID:', task.id,
            //     'Status:', task.status,
            //     'HandoverTo:', task.handoverTo,
            //     'Match?', statusMatch && Number(task.handoverTo) === userInfo.id
            // );
            return statusMatch && Number(task.handoverTo) === userInfo.id;
        }

        return statusMatch;
    });


    // Function to handle tab clicks
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };



    const onTaskCompleted = async (id) => {
        if (userInfo) {
            const result = await completedTask({
                "taskId": id,
                "operationUserId": userInfo.id
            });

            if (result.data.status == 1) {
                showSuccess("Task Completed Successfully!")
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        } else {
            showError("Sorry!", "User Not Found!")
        }
    }
    // ----------------------------------------------------------------
    // TASK CARD COMPONENT
    // ----------------------------------------------------------------

    const TaskCard = ({ task, handleAction }) => {
        const timeSlot = task.slot ? `${task.slot.startTime.substring(0, 5)} - ${task.slot.endTime.substring(0, 5)}` : 'N/A';
        const creationTime = formatDateTime(task.createdAt);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [taskData, setTaskData] = useState({});

        const isActionable = task.status === 'NEW_REQUEST';

        const PriorityBadge = ({ priority }) => {
            // Return null if no priority/status is provided to avoid rendering an empty badge
            if (!priority) {
                return null;
            }

            const statusText = priority.toUpperCase();
            let colorClass = '';


            // Determine the color class based on the status text
            switch (statusText) {
                case 'CANCELLED':
                case 'HIGH':
                    colorClass = 'bg-red-100 text-red-800';
                    break;
                case 'COMPLETED':
                    colorClass = 'bg-green-100 text-green-800';
                    break;
                case 'PENDING':
                case 'NORMAL':
                case 'MEDIUM':
                    colorClass = 'bg-yellow-100 text-yellow-800';
                    break;
                case 'LOW':
                    colorClass = 'bg-blue-100 text-blue-800';
                    break;
                default:
                    colorClass = 'bg-gray-100 text-gray-800';
                    break;
            }

            return (
                <span className={`mr-2 mb-1 px-2.5 py-0.5 inline-flex text-[12px] leading-5 font-semibold rounded-full ${colorClass}`}>
                    {statusText}
                </span>
            );
        };

        return (
            <div className="bg-white rounded-lg shadow-md p-3 mb-3 flex border border-gray-200 hover:shadow-lg transition duration-200">
                {/* Status/Icon Panel */}
                <div className="w-12 flex-shrink-0 flex items-center justify-center bg-green-500 text-white rounded-l-md text-xl font-bold">
                    {isActionable ? '🆕' : '✔️'}
                </div>

                {/* Text Content Panel */}
                <div className="flex-grow flex justify-between items-start md:items-center pl-4">
                    <div className="w-full">
                        {/* Top Bar (Task Type & Slot) */}
                        <div className="flex flex-wrap justify-between items-start border-b pb-2 mb-2">
                            <p className="text-sm font-semibold text-gray-700 m-0">
                                <span className='mr-2'>Pickup Request</span>
                                {/* <span>{task.taskType}</span> */}
                                <PriorityBadge priority={task.priority} />
                                {task.status === "CANCELLED" && task.cancelReason && (

                                    <PriorityBadge priority={task.status} />

                                )}
                                {task.status === "REJECTED" && (
                                    <PriorityBadge priority={task.status} />

                                )}

                            </p>

                            <p className="text-sm font-medium text-green-600 m-0">Slot Time: {timeSlot}</p>
                        </div>

                        {/* Bottom Bar (Time, ID, Address/Client) */}
                        <div className="text-xs text-gray-600 space-y-1 flex-wrap">
                            <p className="text-xs font-semibold text-gray-700 mb-2">
                                {/* Pickup: {task.pickupAddress} */}
                                Client Name: {task.pickupClient?.clientName}
                            </p>
                            <div className="flex justify-between items-center flex-wrap">
                                <p className="text-xs mb-2">
                                    <span className="font-semibold text-gray-500">Task ID:</span> {task.id}
                                </p>
                                <p className="text-xs text-gray-500 mb-2">Created: {creationTime}</p>
                                {task.assignedTo && task.assignedUser && (
                                    // <PriorityBadge priority={task.assignedUser?.employeeName} />
                                    <p className="text-xs font-semibold text-gray-500 mb-2">Assign To: {task?.assignedUser?.employeeName}</p>

                                )}

                            </div>
                        </div>

                        {task.status === "CANCELLED" && task.cancelReason && (
                            <p className="text-xs text-red-600 font-semibold mt-1">
                                Cancel Reason: {task.cancelReason}
                            </p>
                        )}
                    </div>
                    {task.status === "HANDOVERED" && (
                        <button
                            onClick={() => onTaskCompleted(task.id)} // Add your navigation function here
                            type="button"
                            className="text-white bg-green-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-1 transition duration-150"
                        >
                            Completed
                        </button>
                    )}
                    {/* Action Block */}
                    <div className="flex-shrink-0 ml-2">
                        {isActionable ? (
                            <button
                                onClick={() => handleAssignAction(task)}
                                className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 text-sm rounded-md transition duration-150 shadow-md"
                            >
                                Assign Task
                            </button>
                        ) : (
                            <button onClick={() => setIsModalOpen(true)} className="text-gray-500 hover:text-gray-700 p-2 rounded-full">
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                        )}
                    </div>

                    {/* asignModal */}
                    {isAssignModalOpen && selectedTask && (
                        <AssignModal
                            allEmployees={allEmployee}
                            selectedTask={selectedTask}
                            onClose={handleCloseModal}
                            onAssignSuccess={handleAssignSuccess}
                        />
                    )}


                    <TaskViewModal
                        taskData={task}
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                    />
                </div>
            </div>
        );
    };

    // const downloadReportApi = async () => {
    //     axios.post(
    //         `${API_BASE_URL}/operation/task/download-report`,
    //         { fromDate: '2025-10-01', toDate: '2025-10-25' },
    //         { responseType: 'blob' }
    //     ).then((response) => {
    //         const url = window.URL.createObjectURL(new Blob([response.data]));
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', `CompletedTasks_${Date.now()}.xlsx`);
    //         document.body.appendChild(link);
    //         link.click();
    //     });
    // }

    const downloadReportApi = async () => {
        if (!reportDates.fromDate || !reportDates.toDate) {
            showError("Oops!", "Please select both From and To dates");
            return;
        }

        axios.post(
            `${API_BASE_URL}/operation/task/download-report`,
            { fromDate: reportDates.fromDate, toDate: reportDates.toDate },
            { responseType: 'blob' }
        ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `CompletedTasks_${Date.now()}.xlsx`);
            document.body.appendChild(link);
            link.click();

            setIsDownloadModalOpen(false); // Close modal after download
            setReportDates({ fromDate: '', toDate: '' });
        });
    }


    // ----------------------------------------------------------------
    // JSX RETURN
    // ----------------------------------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="bg-gray-50">
            <div className="main-wrap">
                <div className="container">
                    <div className="title">
                        <h4>Task Dashboard</h4>
                    </div>

                    {/* Filter */}
                    <div className="mb-3">
                        <div className="rounded-lg shadow-sm overflow-hidden border border-gray-200">
                            <button
                                className="w-full flex justify-between shadow-none items-center px-4 py-3 font-medium text-gray-800 bg-white hover:bg-gray-100 focus:outline-none focus:ring"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <span>Filter</span>
                                <i
                                    className={`fa-solid fa-chevron-down ml-2 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                                        }`}
                                ></i>
                            </button>



                            <div
                                className={`overflow-hidden transition-all bg-white duration-300 ease-in-out ${isOpen ? "max-h-screen" : "max-h-0"
                                    }`}
                            >
                                <div className="p-3">
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-3 gap-y-2">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Date Range</label>
                                            <input type="date"
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500" />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Centre</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Centre A</option>
                                                <option>Centre B</option>
                                                <option>Centre C</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Client</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Client 1</option>
                                                <option>Client 2</option>
                                                <option>Client 3</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Client Group</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Group A</option>
                                                <option>Group B</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">District</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>District 1</option>
                                                <option>District 2</option>
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Area</label>
                                            <select
                                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500">
                                                <option>Area 1</option>
                                                <option>Area 2</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="flex justify-end gap-1 mt-4">
                                        <button className="bg-blue-500 text-white font-sm py-2 px-3 rounded text-sm theme_btn">
                                            Apply Filter
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Filter */}

                    <div className="staus-tab bg-white rounded-lg shadow-xl p-4 border-t-4 border-green-600">

                        {/* Navigation Tabs */}
                        <ul className="flex flex-wrap border-b border-gray-200 mb-4">
                            {Object.keys(tabStatusMap).map(tabId => (
                                <li className="mr-0" key={tabId}>
                                    <button
                                        className={`px-2 py-2 md:px-4 text-sm font-medium rounded-t-lg transition duration-200 ${activeTab === tabId
                                            ? 'bg-white border-b-2 border-green-600 text-green-600 font-semibold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                                            }`}
                                        onClick={() => handleTabClick(tabId)}
                                        role="tab"
                                    >
                                        {tabId.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')}
                                    </button>
                                </li>
                            ))}
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content">
                            {isLoading ? (
                                <p className="text-center py-8 text-green-600 font-medium">Loading tasks from API...</p>
                            ) : (
                                // Render the content only for the active tab
                                <div className="task-list-container">
                                    <h5 className="flex items-center justify-between mb-4 text-lg font-semibold text-gray-800">
                                        <span>
                                            {activeTab
                                                .split('-')
                                                .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                                                .join(' ')} Tasks ({filteredTasks.length})
                                        </span>
                                        {
                                            activeTab == 'completed' && (

                                                <button
                                                    onClick={() => setIsDownloadModalOpen(true)}
                                                    className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md shadow-sm transition"
                                                >
                                                    <i class="far fa-file-alt"></i>
                                                    {/* <span>Download</span> */}
                                                </button>

                                            )
                                        }

                                    </h5>


                                    <div className="task-main-wrap space-y-4">
                                        {filteredTasks.length > 0 ? (
                                            filteredTasks.map(task => (
                                                <TaskCard
                                                    key={task.id}
                                                    task={task}
                                                    handleAction={handleAssignAction}
                                                    onTaskCompleted={onTaskCompleted}
                                                />
                                            ))
                                        ) : (
                                            <p className="text-center py-8 text-gray-500">No tasks found!</p>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>

            {isDownloadModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-md w-96">
                        <h3 className="text-lg font-semibold mb-4">Download Report</h3>

                        <div className="mb-4">
                            <label className="block mb-1 font-medium">From Date</label>
                            <input
                                type="date"
                                className="w-full border border-gray-300 rounded p-2"
                                value={reportDates.fromDate}
                                onChange={e => setReportDates(prev => ({ ...prev, fromDate: e.target.value }))}
                            />
                        </div>

                        <div className="mb-4">
                            <label className="block mb-1 font-medium">To Date</label>
                            <input
                                type="date"
                                className="w-full border border-gray-300 rounded p-2"
                                value={reportDates.toDate}
                                onChange={e => setReportDates(prev => ({ ...prev, toDate: e.target.value }))}
                            />
                        </div>

                        <div className="flex justify-end gap-2">
                            <button
                                className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded"
                                onClick={() => setIsDownloadModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                                onClick={downloadReportApi}
                            >
                                Download
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
            />
        </div>
    )


}

export default OperationDashboard;